import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MemberStatusEnum } from 'src/shared/models/enums/memberStatusEnum';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { MemberStatus } from '../models/memberStatus';

type MemberStatusesProps = {
  status: MemberStatus | null | undefined;
  resDate: string | undefined;
  chipSize: 'small' | 'medium' | undefined;
};

export const MemberStatuses = (props: MemberStatusesProps) => {
  const { status, resDate, chipSize } = props;
  const { t } = useTranslation(['member']);
  if (!status) return <></>;

  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 }, '.MuiChip-label': { lineHeight: 'normal' } }}>
      {status.id === MemberStatusEnum.Paid && (
        <Tooltip describeChild title={`${t('member:memberStatuses.Payed')}`} arrow>
          <CustomChip label={t('member:memberStatuses.Payed')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status.id === MemberStatusEnum.NotPaid && (
        <Tooltip describeChild title={`${t('member:memberStatuses.NotPayed')}`} arrow>
          <CustomChip label={t('member:memberStatuses.NotPayed')} color='error' size={chipSize} />
        </Tooltip>
      )}
      {status.id === MemberStatusEnum.NewMember && (
        <Tooltip describeChild title={`${t('member:memberStatuses.Interested')}`} arrow>
          <CustomChip label={t('member:memberStatuses.Interested')} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {status.id === MemberStatusEnum.NotMember && (
        <Tooltip describeChild title={`${t('member:memberStatuses.SecedeWithDate', { resDate })}`} arrow>
          <CustomChip label={t('member:memberStatuses.Secede')} color='info' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
